import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { NavigationComponent } from '../navigation/navigation.component';
import { NavigationService } from '../../services/navigation.service';
import { Subscription } from 'rxjs';
import { ClientSelectionService } from '../clients/client-selection.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  standalone: false,
})
export class HomeComponent implements OnInit, OnDestroy {
  selectedMenuItem: string = 'Home';
  isMenuExpanded: boolean = true;
  selectedClientID!: number;
  private subscription: Subscription = new Subscription();

  constructor(
    @Inject(NavigationService) private navigationService: NavigationService,
    @Inject(ClientSelectionService)
    private clientService: ClientSelectionService,
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.navigationService.selectedMenuItem$.subscribe((menuItem: string) => {
        this.selectedMenuItem = menuItem;
        console.log(this.selectedMenuItem);
      }),
    );

    this.subscription.add(
      this.navigationService.isMenuExpanded$.subscribe(
        (isExpanded: boolean) => {
          this.isMenuExpanded = isExpanded;
        },
      ),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
